import { Component, HostListener, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { ThemeService } from 'src/app/shared/services/theme.service';
import { faSignOut } from '@fortawesome/free-solid-svg-icons';
import { faEarthAmericas } from '@fortawesome/free-solid-svg-icons';
import { faAnkh } from '@fortawesome/free-solid-svg-icons';
import { faGlobe } from '@fortawesome/free-solid-svg-icons';
import { faGear } from '@fortawesome/free-solid-svg-icons';
import { environment } from '../../../../../../environments/environment';

@Component({
  selector: 'app-desktop-navbar',
  templateUrl: './desktop-navbar.component.html',
  styleUrls: ['./desktop-navbar.component.scss'],
})
export class DesktopNavbarComponent implements OnInit {
  @Input() activePage!: string;
  @Input() isViewer!: boolean;
  @Input() isAdmin!: boolean;
  @Input() isSuperAdmin!: boolean;
  @Input() isImageFound!: boolean;
  @Input() username!: string;
  @Input() region!: string;
  @Input() userImage!: any;

  isClickedUserImage: boolean = false;

  faSignOut = faSignOut;
  faEarthAmericas = faEarthAmericas;
  faAnkh = faAnkh;
  faGlobe = faGlobe;
  faGear = faGear;
  environmentColor = environment.color;

  constructor(
    private router: Router,
    private authService: MsalService,
    private themeService: ThemeService
  ) {}

  ngOnInit(): void {}

  navigateTo(url: string) {
    this.router.navigateByUrl(url);
    this.setActivePage(url);
  }

  setActivePage(url: string) {
    if (url.includes('create')) {
      this.activePage = 'CREATE USERS';
    } else if (url.includes('lookup')) {
      this.activePage = 'LOOKUP USERS';
    } else if (url.includes('update')) {
      this.activePage = 'UPDATE USERS';
    } else if (url.includes('delete')) {
      this.activePage = 'DELETE USERS';
    } else if (url.includes('restore')) {
      this.activePage = 'RESTORE USERS';
    } else if (url.includes('settings')) {
      this.activePage = 'SETTINGS';
      this.isClickedUserImage = false;
    } else {
      this.activePage = 'HOME';
    }
  }

  onClickUserImage() {
    this.isClickedUserImage = !this.isClickedUserImage;
  }

  changeRegion(region: string) {
    localStorage.setItem('region', region);
    if (this.router.url == '/') {
      window.location.reload();
    } else {
      this.router.navigateByUrl('/');
      this.isClickedUserImage = false;
    }
    this.region = localStorage.getItem('region') || '';
    this.activePage = 'HOME';
    region = region.replace(' ', '');
    this.themeService.setTheme(region);
  }

  logout() {
    this.authService.logout();
  }

  @HostListener('document:click', ['$event'])
  documentClick(event: MouseEvent) {
    let elementId: string = (event.target as HTMLImageElement).id;
    if (elementId !== 'user-profile-info' && elementId != 'user-profile-info-image-not-found') {
      this.isClickedUserImage = false;
    }
  }
}
